// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="pre-terminate box">
  <sub-header header="\$ctrl.title"></sub-header>
  <div class="pre-terminate-by-gl content">
    <form name="loanPreTerminateForm">
      <form-section>
        <loan-pre-terminate
          form-name="\$ctrl.waiveForm"
          max-values='\$ctrl.maxValues'
          payment-request='\$ctrl.paymentRequest'
          waive-request='\$ctrl.waiveRequest'
          loan='\$ctrl.loan'></loan-pre-terminate>

        <table class="table pre-terminate-by-gl__additional-info">
          <tr>
            <td></td>
            <td>Invoice:</td>
            <td>
              <input type="text"
                     ng-model="\$ctrl.officialReceipt"
                     required>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Category:</td>
            <td>
              <gl-category-select
                ng-required="true"
                ng-model="\$ctrl.category"
                single-accounts-only="true"
                action-type="'LOAN_GL_PAYMENT'">
              </gl-category-select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Remarks:</td>
            <td>
              <input type="text"
                     ng-model="\$ctrl.remarks"
                     maxlength="512"
                     required>
            </td>
          </tr>
        </table>

        <div class="buttons">
          <button class="btn btn-warning"
                  ng-click="\$ctrl.redirectBack()">
            Cancel
          </button>
          <button class="btn btn-success"
                  ng-click="\$ctrl.preTerminate()"
                  ng-disabled="\$ctrl.isPreTerminateDisabled(loanPreTerminateForm)">
            {{'pre-terminate' | translate:'LOAN'}}
          </button>
        </div>
      </form-section>
    </form>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pre-terminate/loan-pre-terminate-by-gl.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;